import * as React from "react";
import { ErrorLogger } from "sb-helpers";
import { DefaultError } from "../DefaultError";
/**
 * ErrorBoundary creates react component that is wrapping
 * all other components activated through BaseBlock thus giving fallback
 * from errors and hoocking up to our error logging service inside the responsive project.
 *
 * Shows {DefaultError} component if error arises.
 */
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.logger = new ErrorLogger();
        this.state = { error: undefined, info: undefined };
    }
    /**
     * Overrides inherited componentDidCatch method
     * @param {Error} error
     * @param {ErrorInfo} errorInfo
     */
    componentDidCatch(error, errorInfo) {
        const err = { error, info: errorInfo };
        this.setState(err);
        this.logger.log({
            error: err.error.toString(),
            stack: err.info.componentStack
        });
    }
    render() {
        return this.state.info ?
            React.createElement(DefaultError, { componentStack: this.state.info.componentStack, error: this.state.error }) :
            React.createElement("sb-comp", null, this.props.children);
    }
}
//# sourceMappingURL=ErrorBoundary.js.map